import request from '@/utils/request'


// 查询干扰类型信息列表
export function listInterferenceType(query) {
  return request({
    url: '/saifuneng/saifuneng-interference-type/list',
    method: 'get',
    params: query
  })
}

// 查询干扰类型信息分页
export function pageInterferenceType(query) {
  return request({
    url: '/saifuneng/saifuneng-interference-type/page',
    method: 'get',
    params: query
  })
}

// 查询干扰类型信息详细
export function getInterferenceType(data) {
  return request({
    url: '/saifuneng/saifuneng-interference-type/detail',
    method: 'get',
    params: data
  })
}

// 新增干扰类型信息
export function addInterferenceType(data) {
  return request({
    url: '/saifuneng/saifuneng-interference-type/add',
    method: 'post',
    data: data
  })
}

// 修改干扰类型信息
export function updateInterferenceType(data) {
  return request({
    url: '/saifuneng/saifuneng-interference-type/edit',
    method: 'post',
    data: data
  })
}

// 删除干扰类型信息
export function delInterferenceType(data) {
  return request({
    url: '/saifuneng/saifuneng-interference-type/delete',
    method: 'post',
    data: data
  })
}

// 查询干扰类型信息列表
export function customList(query) {
  return request({
    url: '/biz/user/page',
    method: 'get',
    params: query
  })
}
